export const VOICE_TOPIC = 'dochat.voice'
const MAX_VOICE_PACKET_BYTES = 32_768
const VOICE_EVENT_TYPES = new Set(['transcript', 'narration', 'playback', 'error', 'timing'])

export function encodeVoiceEvent(event) {
  return new TextEncoder().encode(JSON.stringify(event))
}

export function decodeVoiceEvent(payload) {
  if (!payload || payload.byteLength > MAX_VOICE_PACKET_BYTES) return null
  try {
    const parsed = JSON.parse(new TextDecoder().decode(payload))
    return parsed && typeof parsed === 'object' && VOICE_EVENT_TYPES.has(parsed.type) ? parsed : null
  } catch {
    return null
  }
}
